import { Field, InputType, ObjectType } from 'type-graphql'

import { modelOptions, Prop } from '@typegoose/typegoose'
import { User } from '../user/User'
import type { UserTypeEnum } from '../user/UserTypeEnum'

@ObjectType('Vendor')
@InputType('VendorInput')
@modelOptions({ schemaOptions: { timestamps: true, strict: false, collection: 'users' } }) //we need to define the collection name here, as the users, because it will use that collection
export class Vendor extends User {
  @Field(() => String)
  @Prop({ type: String, default: 'Vendor' })
  declare type: UserTypeEnum

  @Field(() => String)
  @Prop({ type: String })
  paymentTerms?: string
}
